import React, { useMemo } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

const getEventColor = (status) => {
    const colors = {
        pending: "#2563eb",
        in_progress: "#f59e0b",
        paused: "#8b5cf6",
        review: "#06b6d4",
        completed: "#16a34a",
        cancelled: "#64748b",
    };

    return colors[status] || "#2563eb";
};

const CalendarView = ({ items = [], loading = false }) => {
    const calendarEvents = useMemo(() => {
        return items.map((item) => ({
            id: String(item.id),
            title: item.business_name
                ? `${item.title} - ${item.business_name}`
                : item.title,
            date: item.calendar_date || item.due_date,
            backgroundColor: getEventColor(item.status),
            borderColor: getEventColor(item.status),
            extendedProps: {
                status: item.status,
                priority: item.priority,
                employees: item.employees,
            },
        }));
    }, [items]);

    return (
        <div
            style={{
                background: "#fff",
                borderRadius: "16px",
                padding: "20px",
                border: "1px solid #e5e7eb",
                minHeight: "500px",
            }}
        >
            {loading ? (
                <div
                    style={{
                        padding: "40px",
                        textAlign: "center",
                        color: "#64748b",
                    }}
                >
                    Loading calendar...
                </div>
            ) : (
                <FullCalendar
                    plugins       =  { [ dayGridPlugin, interactionPlugin ] }
                    initialView   =  "dayGridMonth"
                    height        = "auto"
                    events        = { calendarEvents }
                    eventDisplay  = "block"
                    eventDidMount = { (info) => {
                        const {
                            status,
                            priority,
                            employees,
                        } = info.event.extendedProps;

                        const employeeText =
                            employees?.length
                                ? `\nEmployees: ${employees.join(", ")}`
                                : "";

                        info.el.title =
                            `Status: ${status || "—"}\n` +
                            `Priority: ${priority || "—"}` +
                            employeeText;
                    }}
                />
            )}
        </div>
    );
};

export default CalendarView;
